export class CandidateShareDetails {
    shortenedUrl: string;
    emailUrl: string;
}
